export default "<div id=\"chartContainer\" [ngStyle]=\"style\"></div>"